import { render, staticRenderFns } from "./dialogEditPosition.vue?vue&type=template&id=3bb3d87f&scoped=true"
import script from "./dialogEditPosition.vue?vue&type=script&lang=js"
export * from "./dialogEditPosition.vue?vue&type=script&lang=js"
import style0 from "./dialogEditPosition.vue?vue&type=style&index=0&id=3bb3d87f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb3d87f",
  null
  
)

export default component.exports